export const environment = {
  production: false,
  name: "preprod",
  SERVER_API_URL: "/api/",
  ssoIssuer: "https://auth.test.k8s.bigcct.be/realms/cullen",
  ssoClientId: "cullen-client",
  ssoScopes: "openid profile email offline_access",
  SITE_BASE_URL: "https://www4.test.k8s.bigcct.be",
};
